import { Component } from '@angular/core';

@Component({
    selector: 'jhi-login-wrapper',
    templateUrl: './login-wrapper.component.html'
})
export class EncoreclientLoginWrapperComponent {

}
